export default __webpack_public_path__ + "static/media/voice_your_opinion.a253d5e0.png";